<template>
  <div class="join-container">
    <!-- 회원가입 페이지 -->
    <div class="join-content">
      <div class="scroll-content main">
        <div class="inner">
          <div class="join-inner-content join-center set-bg">
            <div class="tit-area">
              <div class="flex">
                <img src="@/assets/images/common/logo/logo.png" alt="강원특별자치도교육청교육과학정보원 메인으로 이동"
                     class="is-pointer" @click="goHome"/>
                <span>통합 회원 가입</span>
              </div>
              <span>회원 유형에 따라 가입 절차가 다르니 <strong>해당하는 유형</strong>을 <strong>선택</strong>해 주세요.</span>
            </div>
            <!-- 라디오 그룹 -->
            <div class="radio-card-group card-type">
              <div class="inner-list">
                <div class="flex align-center mr25 mob-is-mb">
                  <!-- 각각 radio-item -->
                  <div class="radio-item">
                    <!-- userType.STUDENT.KEY 변경 해야합니다. -->
                    <input type="radio" name="joinRadioGroup" :value="userType.STUDENT.KEY"
                           id="studentUnderGroup" @click="changeUserType( userType.STUDENT.KEY )"/>
                    <label for="studentUnderGroup" class="inner-label">
                      <span class="img-area is-change__width">
                        <img src="@/assets/images/portal/icon/join/icon_student1.png" alt=""/>
                      </span>
                      <span class="label radio-label">학생</span>
                      <span class="card-txt">
                        <span class="color-primary bold">만 14세 미만</span> 학생들을 위한 <br>
                        회원가입 절차입니다.
                      </span>
                      <!-- 이동영역 -->
                      <el-button type="primary"
                                 @click="goJoin( userType.STUDENT.KEY , $constant.FLAG_YN.YES )"
                                 class="search-btn is-shadow">
                        <span>가입하기</span>
                        <span class="material-icons md">chevron_right</span>
                      </el-button>
                    </label>
                  </div>
                  <!-- 각각 radio-item -->
                  <div class="radio-item">
                    <input type="radio" name="joinRadioGroup" :value="userType.STUDENT.KEY"
                           id="studentMoreThanGroup"
                           @click="changeUserType( userType.STUDENT.KEY )"/>
                    <label for="studentMoreThanGroup" class="inner-label">
                    <span class="img-area">
                      <img src="@/assets/images/portal/icon/join/icon_school_bag3.png"
                           alt=""/>
                    </span>
                      <span class="label radio-label">학생</span>
                      <span class="card-txt">
                      <span class="color-primary bold">만 14세 이상</span> 학생들을 위한 <br>
                      회원가입 절차입니다.
                    </span>
                      <!-- 이동영역 -->
                      <el-button type="primary" @click="goJoin( userType.STUDENT.KEY )"
                                 class="search-btn is-shadow">
                        <span>가입하기</span>
                        <span class="material-icons md">chevron_right</span>
                      </el-button>
                    </label>
                  </div>
                </div>
                <div class="flex align-center">
                  <!-- 각각 radio-item -->
                  <div class="radio-item">
                    <input type="radio" name="joinRadioGroup" :value="userType.PARENT.KEY"
                           id="familyGroup" @click="changeUserType( userType.PARENT.KEY )"/>
                    <label for="familyGroup" class="inner-label">
                    <span class="img-area">
                      <img src="@/assets/images/portal/icon/join/icon_parent2.png" alt=""/>
                    </span>
                      <span class="label radio-label">학부모</span>
                      <span class="card-txt">
                      학부모를 위한 <br>
                      회원가입 절차입니다.
                    </span>
                      <!-- 이동영역 -->
                      <el-button type="primary" @click="goJoin( userType.PARENT.KEY )"
                                 class="search-btn is-shadow">
                        <span>가입하기</span>
                        <span class="material-icons md">chevron_right</span>
                      </el-button>
                    </label>
                  </div>
                  <!-- 각각 radio-item -->
                  <div class="radio-item">
                    <input type="radio" name="joinRadioGroup" :value="userType.NORMAL.KEY"
                           id="commonGroup" @click="changeUserType( userType.NORMAL.KEY )"/>
                    <label for="commonGroup" class="inner-label">
                    <span class="img-area">
                      <img src="@/assets/images/portal/icon/join/icon_book2.png" alt=""/>
                    </span>
                      <span class="label radio-label">일반</span>
                      <span class="card-txt">
                      일반회원을 위한 <br>
                      회원가입 절차입니다.
                    </span>
                      <!-- 이동영역 -->
                      <el-button type="primary" @click="goJoin( userType.NORMAL.KEY )"
                                 class="search-btn is-shadow">
                        <span>가입하기</span>
                        <span class="material-icons md">chevron_right</span>
                      </el-button>
                    </label>
                  </div>
                  <!-- 각각 radio-item -->
                  <div class="radio-item">
                    <input type="radio" name="joinRadioGroup" :value="userType.STAFF_GANGWON.KEY"
                           id="teacherGroup" @click="changeUserType( userType.STAFF_GANGWON.KEY )"/>
                    <label for="teacherGroup" class="inner-label">
                    <span class="img-area">
                      <img src="@/assets/images/portal/icon/join/icon_teacher2.png" alt=""/>
                    </span>
                      <span class="label radio-label">교직원</span>
                      <span class="card-txt">
                      강원특별자치도내 교직원을 위한 <br>
                      회원가입 절차입니다.
                    </span>
                      <!-- 이동영역 -->
                      <el-button type="primary" @click="goJoin( userType.STAFF_GANGWON.KEY )"
                                 class="search-btn is-shadow">
                        <span>가입하기</span>
                        <span class="material-icons md">chevron_right</span>
                      </el-button>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 통합 회원가입 -->
            <div class="caption-area">
              <!-- 회원가입 주의 사항 -->
              <div class="inner-desc info-box">
                <div class="box-body is-mob-bg">
                  <span class="inner-tit">회원가입 주의 사항</span>
                  <div class="inner-box">
                    <p>
                      <span class="row">이용약관 및 개인정보 수집 이용 동의하신 후 본인확인 절차가 진행됩니다.</span>
                      <span class="row">
                        고객님께서는 개인정보보호법에 따라 개인정보 수집 및 이용 동의를 거부하실
                        수 있으며, 거부 시에는 강원교육포털 서비스 이용에 제한이 있습니다.
                      </span>
                      <span class="row">회원가입은 본인명의로 하나의 아이디만 만들 수 있습니다.</span>
                      <span class="row">만 14세 미만 학생은 보호자(법정대리인)와 같이 해야 합니다.</span>
                      <span class="row">강원특별자치도교육청교육과학정보원 통합로그인시스템 관련 문의는 1533-3280 로 전화바랍니다</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="btn-area">
                <el-button type="create-line" class="join-footer-btn"
                           @click=" $router.push( '/portal/user/main/user_main' ) ">
                  <span>취소</span>
                </el-button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "join_main",

  data() {
    return {

      // 유저 타입 상수
      userType: $nuxt.$constant.USER_TYPE,

      // 유저 타입
      selectUserType: ""
    }
  },

  methods: {

    // userType 선택
    changeUserType( selectUserType ) {
      this.selectUserType = selectUserType;
    },

    // join push
    async goJoin( selectUserType, isChild = this.$constant.FLAG_YN.NO ) {
      if ( this.$validate.isEmpty( selectUserType ) ) {
        this.$util.rsAlertUtils.rsAlert( { title: "회원 유형", contents: "회원 유형을 선택해주세요." } );
        return;
      }

      // 교직원 클릭시 한번더 안내처리.
      if ( this.$constant.USER_TYPE.STAFF_GANGWON.KEY === selectUserType ) {

        await this.$alert( `ㆍ 강원특별자치도교육청 소속 교직원만 회원가입이 <br class="join-alert__br2"> 가능합니다. <br>ㆍ 교직원 아이디는 정해진 규칙에 따라 새로운 통합 아이디(<b style="margin-left: 0px">"NEIS ID"</b>${this.$constant.WORKSPACE_ID_VALIDATION.DOMAIN})로 생성됩니다 <br>ㆍ 회원가입 전에 나이스 개인번호를 미리 준비하세요.`,
          '교직원 회원가입 안내',
          {
            dangerouslyUseHTMLString: true,
            showClose: false,
            customClass: 'join-alert',
          } );
      }

      this.$router.push( {
        path: '/portal/user/join/join_write',
        query: {
          userType: selectUserType,
          isChild: isChild
        }
      } );
    },

    goHome() {
      this.$router.push( {path: '/portal/user/main/user_main',} );
    }

  }
}
</script>
<style scoped>
</style>
